import './bullseye.css';
export default {
  "bullseye": "pf-l-bullseye"
};